import { Anchor, Box, Text } from '@zillow/constellation-10';

import { MODES } from '../../constants';

import type { MODES_VALUES } from '../../constants';

const CONFIG = {
  phone: {
    errorText:
      'You have exceeded the maximum verification attempts for this number. Please provide a different phone number or ',
  },
  email: {
    errorText: 'You have exceeded the maximum verification attempts for this email. Please ',
  },
};

type Props = {
  verificationMode?: MODES_VALUES;
};

const MaxAttemptsError = ({ verificationMode = MODES.PHONE }: Props): JSX.Element => (
  <Box css={{ marginTop: '400' }}>
    <Text
      textStyle="body-sm"
      css={{ color: 'text.feedback.critical.strong', lineHeight: '18px', textAlign: 'center' }}
      asChild
    >
      <p>
        {CONFIG[verificationMode].errorText}
        <Anchor target="_blank" href="https://help.zillowrentalmanager.com/hc/en-us/requests/new">
          contact customer support.
        </Anchor>
      </p>
    </Text>
  </Box>
);

export default MaxAttemptsError;
